import { Vehicle } from '../../maintenance/models/vehicle.interface';

export interface ReportsState {
  readonly vehicles: Vehicle[];
}

export const initialState: ReportsState = { vehicles: [] };
